import React from 'react';
import { SummaryLegalTextStyledAC } from './AC/SummaryLegalTextStyled.AC';
import { SummaryLegalTextStyledAP } from './AP/SummaryLegalTextStyled.AP';
import { SummaryLegalTextStyledDS } from './DS/SummaryLegalTextStyled.DS';
import { SummaryLegalTextStyledOV } from './OV/SummaryLegalTextStyled.OV';
import { SummaryLegalTextStyled } from './SummaryLegalTextStyled';
import { BRAND } from '../../constants/main';
import { SC } from '../../styles/theme';

export interface SummaryLegalTextProps extends SC {}

const SummaryLegalText = (props: SummaryLegalTextProps) => {
    if (BRAND === 'OV') return <SummaryLegalTextStyledOV {...props} />;
    if (BRAND === 'AC') return <SummaryLegalTextStyledAC {...props} />;
    if (BRAND === 'AP') return <SummaryLegalTextStyledAP {...props} />;
    if (BRAND === 'DS') return <SummaryLegalTextStyledDS {...props} />;
    return <SummaryLegalTextStyled {...props} />;
};

export default SummaryLegalText;
